var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defineComponent as _defineComponent } from 'vue';
import { computed, ref } from "vue";
//@ts-ignore missing typedefs
import VirtualList from "vue-virtual-scroll-list";
import { copyDataset } from "@/api/datasets";
import { useAnimationFrameResizeObserver } from "@/composables/sensors/animationFrameResizeObserver";
import { useAnimationFrameScroll } from "@/composables/sensors/animationFrameScroll";
import { Toast } from "@/composables/toast";
import { useHistoryStore } from "@/stores/historyStore";
import localize from "@/utils/localization";
import HistoryDropZone from "../CurrentHistory/HistoryDropZone.vue";
import MultipleViewItem from "./MultipleViewItem.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'MultipleViewList',
    props: {
        histories: null,
        selectedHistories: null,
        filter: { default: "" }
    },
    setup(__props) {
        const props = __props;
        const historyStore = useHistoryStore();
        const scrollContainer = ref(null);
        const { arrived } = useAnimationFrameScroll(scrollContainer);
        const isScrollable = ref(false);
        useAnimationFrameResizeObserver(scrollContainer, ({ clientSize, scrollSize }) => {
            isScrollable.value = scrollSize.width >= clientSize.width + 1;
        });
        const scrolledLeft = computed(() => !isScrollable.value || arrived.left);
        const scrolledRight = computed(() => !isScrollable.value || arrived.right);
        const showDropZone = ref(false);
        const historyPickerText = computed(() => showDropZone.value ? localize("Create new history with this item") : localize("Select histories"));
        const processingDrop = ref(false);
        function onDrop(evt) {
            return __awaiter(this, void 0, void 0, function* () {
                if (processingDrop.value) {
                    showDropZone.value = false;
                    return;
                }
                processingDrop.value = true;
                showDropZone.value = false;
                let data;
                try {
                    data = JSON.parse(evt.dataTransfer.getData("text"))[0];
                }
                catch (error) {
                    // this was not a valid object for this dropzone, ignore
                }
                if (data) {
                    yield historyStore.createNewHistory();
                    const currentHistoryId = historyStore.currentHistoryId;
                    const dataSource = data.history_content_type === "dataset" ? "hda" : "hdca";
                    if (currentHistoryId) {
                        yield copyDataset(data.id, currentHistoryId, data.history_content_type, dataSource)
                            .then(() => {
                            if (data.history_content_type === "dataset") {
                                Toast.info(localize("Dataset copied to new history"));
                            }
                            else {
                                Toast.info(localize("Collection copied to new history"));
                            }
                            historyStore.loadHistoryById(currentHistoryId);
                        })
                            .catch((error) => {
                            Toast.error(error);
                        });
                        historyStore.pinHistory(currentHistoryId);
                    }
                    processingDrop.value = false;
                }
            });
        }
        return { __sfc: true, historyStore, props, scrollContainer, arrived, isScrollable, scrolledLeft, scrolledRight, showDropZone, historyPickerText, processingDrop, onDrop, VirtualList, HistoryDropZone, MultipleViewItem };
    }
});
